var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-detail-data"},[_c('st-entity-file-manager',{key:_vm.id,attrs:{"entity-id":_vm.patientId,"origin-id":_vm.id,"origin-type":"medical_record","readonly":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }